<template>
    <div>
        <toolbar
            v-if="toolbar"
            hide-navigation
        />
        <v-container fluid>
            <v-layout
                column
                align-center
            >
                <template v-if="step === 'search'">
                    <search
                        @found-result="onFoundResult"
                    />
                </template>
                <template v-else-if="step === 'invoice'">
                    <invoice-view
                        :invoice="invoice"
                        :invoice-card-data="invoiceCardData"
                        :product-return="productReturn"
                        @refresh-data="onRefreshData"
                        @back="onInvoiceBack"
                        @create="onCreate"
                        @see-confirmation="onSeeConfirmation"
                        @edit="onEdit"
                    />
                </template>
                <template v-else-if="step === 'confirmation'">
                    <return-confirmation
                        @back="onConfirmationBack"
                    />
                </template>
                <template v-else-if="step === 'wizard'">
                    <invoice-wizard
                        :invoice="invoice"
                        :invoice-card-data="invoiceCardData"
                        :product-return="productReturn"
                        :is-edit="editWizard"
                        @back="onWizardBack"
                        @created="onCreatedReturn"
                        @updated="onUpdatedReturn"
                    />
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import axios from 'axios'
import Toolbar from '../../components/Toolbar'
import Search from './Search'
import InvoiceView from './InvoiceView'
import InvoiceWizard from './InvoiceWizard'
import ReturnConfirmation from './ReturnConfirmation'
import SnackBus from '../../utils/buses/snackBus'

export default {
    components: {
        Toolbar,
        Search,
        InvoiceView,
        InvoiceWizard,
        ReturnConfirmation
    },
    props: {
        toolbar: {
            type: Boolean,
            default: true
        }
    },
    data () {
        // TODO - move invoice & product return data to a vue bus.
        // this will help organize this workflow (the bus will handle
        // the data and this component will only focus on switching views.)
        return {
            step: 'search', // search, invoice, confirmation, or wizard
            invoiceCardData: null,
            invoice: null,
            productReturn: null,
            editWizard: false
        }
    },
    created () {
        const rid = this.$route.query.rid

        if (rid) {
            // unset step to show nothing
            this.step = null

            this.getData(rid)
                .then(res => {
                    if (this.productReturn) {
                        this.step = 'invoice'
                    } else {
                        SnackBus.showMessage('Product Return not found. Navigating to Search')
                        this.step = 'search'
                    }
                })
                .catch(err => {
                    console.log('Return Link Error', err)
                    SnackBus.showMessage('There was an error with your request. Navigating to Search', 'error')
                    this.step = 'search'
                })
        }
    },
    methods: {
        /**
         * get return data
         */
        getData (id) {
            return axios.get('/api/returns/' + id)
                .then(res => {
                    const productReturn = res.data

                    if (productReturn) {
                        this.productReturn = productReturn

                        const metadata = productReturn.metadata
                        this.invoiceCardData = {
                            invoiceNumber: productReturn.invoiceNumber,
                            partnerNumber: metadata.partnerNumber,
                            amountPaid: metadata.amountPaid,
                            salesRep: metadata.salesRep,
                            projectName: metadata.projectName
                        }
                    }
                })
        },
        /**
         * refresh data
         */
        onRefreshData () {
            this.getData(this.productReturn.uuid)
                .catch(err => {
                    console.log('Refresh Data Error', err)
                    SnackBus.showMessage('Error refreshing data', 'error')
                })
        },
        onFoundResult (result) {
            const {
                invoice,
                productReturn
            } = result
            this.invoiceCardData = {
                invoiceNumber: invoice.invoiceNumber,
                partnerNumber: invoice.partner.partnerNumber,
                amountPaid: invoice.amountPaid,
                salesRep: invoice.project.primaryRep.fullName,
                projectName: invoice.project.projectName
            }
            this.invoice = invoice
            this.productReturn = productReturn
            this.step = 'invoice'
        },
        onInvoiceBack () {
            this.step = 'search'
            // reset data
            this.invoice = null
            this.productReturn = null
            this.products = []
        },
        onCreate () {
            this.step = 'wizard'
            this.editWizard = false
        },
        onWizardBack () {
            this.step = 'invoice'
        },
        onCreatedReturn (productReturn) {
            this.productReturn = productReturn
            this.step = 'confirmation'
        },
        onSeeConfirmation () {
            this.step = 'confirmation'
        },
        onConfirmationBack () {
            this.step = 'invoice'
        },
        onEdit () {
            this.step = 'wizard'
            this.editWizard = true
        },
        onUpdatedReturn (productReturn) {
            this.productReturn = productReturn
            this.step = 'invoice'
        }
    }
}
</script>

<style>

</style>
